import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import { Container } from "@mui/material";
import { getRequest } from "../../../API/IP";
import { getRequestGlobal } from "../../../API/global";
import { convertDate } from "../../Helper";
import { convertDateToIndianFormat } from "../../Helper";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// import logo from '../../../images/pecock.png';
import logo from "../../../images/IFFFI_LOGO.png";
import logo1 from "../../../images/ashok-logo.png";
import logo2 from "../../../images/NFDC-Logo.png";
import { styled } from "@mui/system";
import FilePresentIcon from "@mui/icons-material/FilePresent";
// Define the custom style
const StickyButton = styled(Button)({
  position: "fixed",
  bottom: "10px", // Or top: '10px' for top positioning
  right: "10px",
  zIndex: 1000,
});

const OttView = () => {
  const [impoData, setImpoData] = useState([]);
  let baseUrl = process.env.REACT_APP_BASE_PREFIX;
  useEffect(() => {
    const ImportantData = async () => {
      if (!baseUrl) {
        return;
      }
      try {
        const response = await fetch(`${baseUrl}/AppData.json`);
        const commonData = await response.json();
        setImpoData(commonData);
      } catch (error) {
        console.error(error, "importent adta error");
      }
    };

    ImportantData();
  }, []);

  const [formData, setFormData] = useState({});
  const [language, setLanguage] = useState({});
  const [genre, setGenre] = useState({});
  const [preEpisodeData, setPreEpisodeData] = useState([]);
  const [coproData, setCoproData] = useState([]);
  const [streemOutData, setStreemOutData] = useState([]);
  const [countryId, setCountryId] = useState({});
  const [screeningData, setScreeningData] = useState([]);

  const [broardcastData, setBroardcastData] = useState([]);
  const [Competition, setCompetition] = useState([]);
  const [createrDetails, setCreaterDetails] = useState([]);
  const [directorDetails, setDirectorDetails] = useState([]);
  const [otherDetails, setOtherDetails] = useState([]);

  const [currDate, setCurrDate] = useState("");
  const [currTime, setCurrTime] = useState("");
  const navigate = useNavigate();
  const { id = null } = useParams();

  const loadPreData = async () => {
    if (id) {
      try {
        const response = await getRequest(`ott/${id}`, {});
        const loadPreData = response.data;
        const documentData = {};
        if (loadPreData.documents) {
          for (const document of loadPreData.documents) {
            documentData[document.documents_type] = {
              file: document.file,
              name: document.documents_name,
            };
          }
        }
        loadPreData.documentData = documentData;
        // console.log({ loadPreData });
        setFormData(loadPreData);
      } catch (error) {
        console.error("Error loading pre data:", error);
      }
    } else {
      console.error("No ID provided.");
    }
  };

  useEffect(() => {
    const date = new Date();
    setCurrDate(date.toLocaleDateString());
    setCurrTime(date.toLocaleTimeString());
    const loadData = async () => {
      try {
        const coproResponse = await getRequest(`ott/${id}/coproducer`);
        const coproData = coproResponse.data;
        setCoproData(coproData);

        const episodeResponse = await getRequest(`ott/${id}/episode`);
        const episodeData = episodeResponse.data;
        setPreEpisodeData(episodeData);

        const languageResponse = await getRequestGlobal("language_list", {});
        setLanguage(languageResponse.data);

        const genreResponse = await getRequestGlobal("genre", {});
        setGenre(genreResponse.data);

        const country = await getRequestGlobal("country", {});
        // console.log({ "countrydata": country.data });
        setCountryId(country.data);

        const streemOut = await getRequest(`ott/${id}/streamed-country`);
        setStreemOutData(streemOut.data);

        const screening = await getRequest(`ott/${id}/threatrical-screening`);
        setScreeningData(screening.data);

        const broardcast = await getRequest(`ott/${id}/broardcast`);
        setBroardcastData(broardcast.data);

        const competition = await getRequest(
          `ott/${id}/international-competition`
        );
        setCompetition(competition.data);

        const createrDetails = await getRequest(`ott/${id}/creator/type/1`);
        setCreaterDetails(createrDetails.data);

        const directorDetails = await getRequest(`ott/${id}/creator/type/2`);
        setDirectorDetails(directorDetails.data);

        const otherDetails = await getRequest(`ott/${id}`);
        setOtherDetails(otherDetails.data);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();
    loadPreData();
  }, []);

  // Handle Print function
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "userDetail",
  });

  const handleRedirect = (tabName) => {
    navigate(`/dashboard/${tabName}`);
  };

  const toRoman = (num) => {
    const romanNumerals = [
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];

    let roman = "";
    for (let [letter, value] of romanNumerals) {
      while (num >= value) {
        roman += letter;
        num -= value;
      }
    }
    return roman;
  };
  return (
    <>
      <div ref={printRef} className="print-page">
        {/* header of Ott View Page */}
        <div className="print-header">
          <div className="d-flex justify-content-between m-1 align-items-center">
            <div className="imgLogo">
              <a href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}>
                <img
                  src={logo}
                  className="mob-logo-left"
                  alt="Logo"
                  width="130px"
                  height="100"
                />
              </a>
            </div>
            <div className="imgLogo">
              <img
                src={logo1}
                alt="Logo"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            {/* <div className="imgLogo">
                        <img
                          src={NFDCimg}
                          className="mob-logo-right"
                          alt="Logo"
                          width="130"
                          height="100"
                        />
                      </div> */}
          </div>
        </div>
        <div className="text-center m-3">
          <h4>Best Web Series (OTT) Award, {impoData?.award_year}</h4>
          <p>Entry Form</p>
        </div>
        <div>
          <Container className="note_p">
            <h5>Instructions</h5>
            <p>
              (1) Please exercise great care in filling out this form as it is
              the primary source of data for the Ministry with respect to this
              award, and no requests for a change of details will be entertained
              at any stage. The information provided will be used for the
              evaluation and selection process.
            </p>
            <p>
              (2) Before filling out the form, kindly read the award regulations
              available on the website{" "}
              <b>www.mib.gov.in, www.iffigoa.org, www.nfdcindia.com</b>
              carefully.
            </p>
            <p>
              (3) The Entry Form must be filled out by the ‘Applicant’ as
              defined in the Regulations.
            </p>
            <p>
              (4) Only one season of the web series will be considered for the
              award as per the Regulations. If multiple seasons of a web series
              are released within the eligibility period, the applicant must
              ensure that the information provided in the form is relevant only
              to the season applied for the award.
            </p>
            <p>
              (5) The Applicant must also ensure that the name(s) indicated in
              the entry form match the credit titles appearing in the web
              series, as the credit titles will be considered for validation if
              required.
            </p>
            {/* <p>
              (6) The last date for submission of online applications is{" "}
              {impoData?.["ott"]?.["last_date"]} till{" "}
              {impoData?.["ott"]?.["last_time"]}
            </p>
            <p>
              (7) The last date for the receipt of the stamped and signed hard
              copy of the submitted online application form, Schedule I
              (declaration letter - annexed in the regulations), details of
              payment of entry fee along with the requisite material is{" "}
              {impoData?.["ott"]?.["last_document"]} till{" "}
              {impoData?.["ott"]?.["last_time"]} In the event that physical
              submission deadline is declared a holiday, the next working day
              will be considered as the final date for receipt of the
              application. (Note: Both the online and hard copy versions of the
              application forms must be the same.)
            </p> */}
            <p>
              (6) The last date for submission of online applications is &nbsp;
              <b>
                {impoData?.["ott"]?.["last_date"]}till{" "}
                {impoData?.["ott"]?.["last_time"]}
              </b>
              , and the last date for the receipt of the stamped and signed hard
              copy of the submitted online application form along with the
              requisite material is &nbsp;
              <b>
                {impoData?.["ott"]?.["last_document"]}till{" "}
                {impoData?.["ott"]?.["last_time"]}
              </b>{" "}
              . In the event that the physical submission deadline is declared a
              holiday, the next working day will be considered as the final date
              for receipt of the application. (Note: Both the online and hard
              copy versions of the application forms must be the same.) Digital signature on original documents to be submitted are not acceptable.
            </p>

            <p> (7) The submission of Online Streaming Link (Vimeo or Google Drive or similar platform link) of all the episodes of the submitted web series is mandatory and it shouldn't be changed or deleted until the last day of the festival, i.e. 28 November, 2026.</p>
          </Container>
        </div>

        {/* Step 1 Details of Web Series */}
        <Container className="viewPrint mt-2">
          {/* <h5>1. Details of Web Series</h5> */}

          <p className="titleoffield-view-ott">
            <b>1. Details of Web Series</b>{" "}
            <span className="text-danger"> *</span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (a) Title of Web Series (in the original language of
                    release) :{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.title}{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (b) English translation of the title :{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.title_in_english}{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">(c) Genre : </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {genre[formData.genre_id] || ""}{" "}
                  </span>{" "}
                </p>
              </div>
              {formData.genre_id == 25 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (c.i) Other Genre :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {" "}
                        {formData.other_genre}{" "}
                      </span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (d) Language in which the Web Series was originally released
                    :{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {" "}
                    {language[formData.language_id] || ""}{" "}
                  </span>{" "}
                </p>
              </div>
              {formData.language_id == 20 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (d.i) Other language :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.other_language}{" "}
                      </span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (e) Whether Subtitle in English :{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.is_subtitle_language_eng === 1 ? "Yes" : "No"}{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (f) Other languages in which subtitles are available (if
                    any) :{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {" "}
                    {language[formData.subtitle_other_language] || ""}{" "}
                  </span>{" "}
                </p>
              </div>
              {formData.subtitle_other_language == 20 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (f.i) Other Subtitle Langauge :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.other_subtitle_language}{" "}
                      </span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </Container>
        </Container>

        {/* Step 2 Film Details */}
        <Container className="viewPrint mt-2">
          {/* <h5>2. Details of Season & Episodes</h5> */}
          <p>
            <b>
              <span className="titleoffield-view-ott">
                <b>2. Details of Season & Episodes </b>
                <span className="text-danger"> *</span>
              </span>
            </b>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">(a) Season : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.season}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (b) Total Runtime (in minutes) :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.runtime}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (c) Number of episodes :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.number_of_episode}
                  </span>
                </p>
              </div>

              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (d) Whether the duration of each episode of the season is 20
                    mins or more:{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.is_long_duration_timing ? "Yes" : "No"}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (e) Release date of the season :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {" "}
                    {convertDate(formData.release_date)}{" "}
                  </span>
                </p>
              </div>

              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    {" "}
                    (f) Whether all the episodes were released on the same date?
                    :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.is_episode_have_same_date ? "Yes" : "No"}{" "}
                  </span>
                </p>
              </div>

              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    {" "}
                    (g) Episodes and Release date :{" "}
                  </span>
                </p>
              </div>

              {preEpisodeData.map((row, index) => (
                <>
                  {/* <p className="m-0 mt-2">
                    <span className="titleoffield-view-out">
                      (g) Episodes and Release date
                    </span>
                  </p> */}
                  <div className="card m-1">
                    <div className="card-body">
                      {/* <p className='titleoffield-view'> Episode's</p> */}
                      <p>({toRoman(index + 1)}) Episode Details</p>
                      <Container>
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              <span className="">Episode Number : </span>
                              <span className="titleoffield-view-span-ott">
                                {row.episode_number}
                              </span>
                            </p>
                          </div>
                          <div className="col-md-6">
                            <p>
                              <span className="">
                                {" "}
                                Release Date of the episode(s) :{" "}
                              </span>
                              <span className="titleoffield-view-span-ott">
                                {" "}
                                {row.release_date}{" "}
                              </span>
                            </p>
                          </div>
                        </div>
                      </Container>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </Container>
        </Container>

        {/* Step 3 Details Of Production */}
        <Container className="viewPrint mt-2">
          {/* <h5>3. Details Of Producer(s)</h5> */}
          <p>
            <b>
              <span className="titleoffield-view-ott">
                <b>3. Details Of Producer(s)</b>{" "}
                <span className="text-danger"> *</span>
              </span>
            </b>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (a) Whether the Web Series is a co-production :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.has_coproduction ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (b) Producer Details :
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.producer_details}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.has_coproduction == 1 && (
                  <>
                    <div className="row">
                      {coproData.map((item, index) => (
                        <div className="col-md-12">
                          <div
                            className="card"
                            style={{
                              width: "100%",
                              marginTop: "10px",
                              marginRight: "15px",
                            }}
                          >
                            <div className="card-body row">
                              <p className="titleoffield-view">
                                ({toRoman(index + 1)}) Producer Details
                              </p>
                              <Container>
                                <div className="row">
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (c) Production Type :{" "}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {" "}
                                        &nbsp;
                                        {item.type == 1
                                          ? "OTT"
                                          : item.type == 2
                                            ? "Production House"
                                            : "Individual Producer"}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(i) Name :</span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {item.name}
                                      </span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(ii) Address :</span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {item.address}
                                      </span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(iii) Phone :</span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {item.phone}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(iv) E-mail :</span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {item.email}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (v) Website (Optional) :
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield-view-span-ott">
                                        {item.website}
                                      </span>
                                    </p>
                                  </div>
                                  {item.type == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          (vi) Whether the OTT Platform has
                                          furnished information under Rule 18 of
                                          IT Rules, 2021 to the Ministry of
                                          Information and Broadcasting,
                                          Government of India :
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="titleoffield-view-span-ott">
                                            {item.is_follow_it_rules
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vii) Whether the Web Series is its
                                            original production. :{" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="titleoffield-view-span-ott">
                                            {item.is_original_production
                                              ? "Yes"
                                              : "No"}{" "}
                                          </span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 2 && item.is_registered == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Production House is
                                            incorporated/registered in India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_registered ? "Yes" : "No"}{" "}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  {item.type == 2 &&
                                    item.is_registered === 0 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Production House is
                                            incorporated/registered in India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_registered ? "Yes" : "No"}{" "}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.i) Please mention the country:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.nationality}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>

                                      {/* <p>(g) Nationality : {item.nationality}</p> */}
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.ii) Upload proof of the PDF:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item?.documents?.[0]?.name}{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  {item.type == 3 &&
                                    item.is_residing_in_country == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Individual Producer
                                            is normally working and residing in
                                            India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item.is_residing_in_country
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 3 &&
                                    item.is_residing_in_country === 0 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Individual Producer
                                            is normally working and residing in
                                            India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item.is_residing_in_country
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.i) Please mention the country :
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item.nationality}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      {/* <p>(i) Please mention the country : {item.nationality}</p> */}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi.i) Upload proof of the
                                        incorporation/registration/Individual in
                                        India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {item?.documents?.[0]?.name}{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                </div>
                              </Container>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="col-md-12 mt-2 text-danger">
                      <p>
                        Note:&nbsp;The name of the OTT
                        Platform/producer(s)/production House(s)/co-producer(s)
                        will be credited as declared in the application form. No
                        request for the change of names would be entertained at
                        any stage.
                      </p>
                    </div>
                  </>
                )}

                {formData.has_coproduction === 0 && (
                  <>
                    <div className="card">
                      <div className="card-body">
                        <p className="titleoffield-view">Producer Details</p>
                        <Container>
                          <div className="row">
                            <div className="col-md-6">
                              <p>
                                <span className="">(c) Production Type : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  &nbsp;
                                  {formData.coproducer_type == 1
                                    ? "OTT"
                                    : formData.coproducer_type == 2
                                      ? "Production House"
                                      : "Individual Producer"}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">(i) Name :</span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {formData.coproducer_name}
                                </span>
                              </p>
                            </div>

                            <div className="col-md-6">
                              <p>
                                <span className="">(ii) Address :</span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {formData.coproducer_address}
                                </span>
                              </p>
                            </div>

                            <div className="col-md-6">
                              <p>
                                <span className="">(iii) Phone :</span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {formData.coproducer_phone}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">(iv) E-mail :</span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {formData.coproducer_email}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">
                                  (v) Website (Optional) :
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {formData.coproducer_website}
                                </span>
                              </p>
                            </div>
                            {formData.coproducer_type == 1 ? (
                              <>
                                <div className="col-md-6">
                                  <p>
                                    (vi) Whether the OTT Platform has furnished
                                    information under Rule 18 of IT Rules, 2021
                                    to the Ministry of Information and
                                    Broadcasting, Government of India :
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="titleoffield-view-span-ott">
                                      {formData.coproducer_is_follow_it_rules
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vii) Whether the Web Series is its
                                      original production. :{" "}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="titleoffield-view-span-ott">
                                      {formData.coproducer_is_original_production
                                        ? "Yes"
                                        : "No"}{" "}
                                    </span>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}

                            {formData.coproducer_type == 2 &&
                              formData.coproducer_is_registered == 1 ? (
                              <>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi) Whether the Production House is
                                      incorporated/registered in India:{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="inputoffield">
                                      {formData.coproducer_is_registered
                                        ? "Yes"
                                        : "No"}{" "}
                                    </span>
                                    <span className="inputoffield"></span>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}

                            {formData.coproducer_type == 2 &&
                              formData.coproducer_is_registered === 0 ? (
                              <>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi) Whether the Production House is
                                      incorporated/registered in India:{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="inputoffield">
                                      {formData.coproducer_is_registered
                                        ? "Yes"
                                        : "No"}{" "}
                                    </span>
                                    <span className="inputoffield"></span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi.i) Please mention the country:
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="inputoffield">
                                      {formData.nationality}
                                    </span>
                                    <span className="inputoffield"></span>
                                  </p>
                                </div>
                                {/* <p>(g) Nationality : {formData.nationality}</p> */}
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi.ii) Upload proof of the PDF:{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      {formData?.documentData?.[7]?.name}{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {formData.coproducer_type == 3 &&
                              formData.coproducer_is_residing_in_country == 1 ? (
                              <>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi) Whether the Individual Producer is
                                      normally working and residing in India:{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      {formData.coproducer_is_residing_in_country
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                            {formData.coproducer_type == 3 &&
                              formData.coproducer_is_residing_in_country == 0 ? (
                              <>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi) Whether the Individual Producer is
                                      normally working and residing in India:{" "}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      {formData.coproducer_is_residing_in_country
                                        ? "Yes"
                                        : "No"}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      (vi.i) Please mention the country :
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <p>
                                    <span className="">
                                      {formData.nationality}
                                    </span>
                                    <span className="inputoffield"> </span>
                                  </p>
                                </div>
                                {/* <p>
                                (g) Nationality : <b>{formData.nationality}</b>
                              </p> */}
                              </>
                            ) : (
                              <></>
                            )}
                            <div className="col-md-6">
                              <p>
                                <span className="">
                                  (vi.i) Upload proof of the
                                  incorporation/registration in India:{" "}
                                </span>
                                <span className="inputoffield"> </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">
                                  {formData?.documentData?.[5]?.name}{" "}
                                </span>
                                <span className="inputoffield"> </span>
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                    <div className="col-md-12 mt-2 text-danger">
                      <p>
                        Note :&nbsp;The name of the OTT
                        Platform/producer(s)/production House(s)/co-producer(s)
                        will be credited as declared in the application form. No
                        request for the change of names would be entertained at
                        any stage.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Container>
        </Container>

        {/* Step 4 OTT - Platform */}
        <Container className="viewPrint mt-2">
          {/* <h5>4. OTT - Platform</h5> */}
          <p>
            <span className="titleoffield-view-ott">
              <b>4. Details of streaming OTT Patform </b>
              <span className="text-danger"> *</span>{" "}
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (a) Name of the OTT Platform where the web series was
                    originally released :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.ott_released_platform}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-out">
                    (b) Other OTT platform(s) on which the Web Series is
                    currently available, if any :{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.is_other_released_platform_available
                      ? "Yes"
                      : "No"}{" "}
                  </span>
                </p>
              </div>

              {formData.is_other_released_platform_available ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-out">
                        Other OTT Platform :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.other_released_platform_available}
                      </span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}

              {/* <h6 className="mt-2">
                {" "}
                5. Other Information <span className="text-danger"> *</span>{" "}
              </h6>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (a) Whether the web series has been streamed outside India :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_released_other_country ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_released_other_country &&
                  streemOutData.length > 0 ? (
                  <>
                    {streemOutData.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  (i) Name of Country :{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {countryId[row.country_id] || ""}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  {" "}
                                  (ii) Name of the OTT Platform:{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.platform_name}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  {" "}
                                  (iii) Date of Release:{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.release_date}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

            
              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (b) Whether the web series has been presented for
                        festival/theatrical screening :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_thretrical_screening ? "Yes" : "No"}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_thretrical_screening &&
                  screeningData.length > 0 ? (
                  <>
                    {screeningData.map((row, index) => (
                      <p key={index}>
                        <Container>
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    (i) Name of the festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.festival_name}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii) Date of the Festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.date_of_festival}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    {" "}
                                    (iii) Address of the Festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.address}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Container>
                      </p>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

            
              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (c) Whether web series has been streamed/broadcasted on
                        the Internet/TV or other media :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_streamed_other_media ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_streamed_other_media &&
                  broardcastData.length > 0 ? (
                  <>
                    {broardcastData.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    (i) Date of the Streaming :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.stream_date}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii)  Name of the platform :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.platform_name}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (d) Whether web series has been participated in any
                        International Competition :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_international_competition ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_international_competition &&
                  Competition.length > 0 ? (
                  <>
                    {Competition.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    (i) Name of the Competition :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.competition_name}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii) Date of the Competition :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.competition_date}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (iii) Details of the Awards won(if any) :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.details}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div> */}
            </div>
          </Container>
        </Container>

        {/* Other Information */}
        <Container className="viewPrint mt-2">
          <p>
            <span className="titleoffield-view-ott">
              <b>5. Other Information</b>
              <span className="text-danger"> *</span>{" "}
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              {/* (A) Whether web series has been streamed outside India */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (a) Whether the web series has been streamed outside
                        India :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_released_other_country ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_released_other_country &&
                  streemOutData.length > 0 ? (
                  <>
                    {streemOutData.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  (i) Name of Country :{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {countryId[row.country_id] || ""}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  {" "}
                                  (ii) Name of the OTT Platform:{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.platform_name}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="titleoffield-view">
                                  {" "}
                                  (iii) Date of Release:{" "}
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.release_date}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

              {/* (B) Whether web series has been presented for festival/theatrical screening */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (b) Whether the web series has been presented for
                        festival/theatrical screening :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_thretrical_screening ? "Yes" : "No"}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_thretrical_screening &&
                  screeningData.length > 0 ? (
                  <>
                    {screeningData.map((row, index) => (
                      <p key={index}>
                        <Container>
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    (i) Name of the festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.festival_name}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii) Date of the Festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.date_of_festival}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view">
                                    {" "}
                                    (iii) Address of the Festival/Screening :{" "}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.address}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Container>
                      </p>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

              {/* (C) Whether web series has been streamed/broadcasted on the Internet/TV or other media */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (c) Whether web series has been streamed/broadcasted on
                        the Internet/TV or other media :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_streamed_other_media ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_streamed_other_media &&
                  broardcastData.length > 0 ? (
                  <>
                    {broardcastData.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    (i) Date of the Streaming :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.stream_date}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii) Name of the platform :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.platform_name}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>

              {/* (D) Whether web series has been participated in any International Competition */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view">
                        (d) Whether web series has been participated in any
                        International Competition :{" "}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="titleoffield-view-span-ott">
                        {formData.is_international_competition ? "Yes" : "No"}{" "}
                      </span>
                    </p>
                  </div>
                </div>

                {formData.is_international_competition &&
                  Competition.length > 0 ? (
                  <>
                    {Competition.map((row) => (
                      <Container>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    (i) Name of the Competition :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.competition_name}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (ii) Date of the Competition :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.competition_date}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view">
                                    {" "}
                                    (iii) Details of the Awards won(if any) :{" "}
                                  </span>
                                  <span className="titleoffield-view-span-ott">
                                    {" "}
                                    {row.details}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Container>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Container>
        </Container>

        {/* Step 5 Director(s)/Creator's Details */}
        <Container className="viewPrint mt-2">
          {/* <h5>5. Director(s)/Creator's Details</h5> */}
          <p>
            <span className="titleoffield-view-ott">
              <b>6. Director(s)/Creator(s) Details </b>
              <span className="text-danger"> *</span>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <h6 style={{ textAlign: "left", color: "gray", padding: "10px" }}>
                (a) Director(s) Details{" "}
              </h6>
              {directorDetails.map((row, index) => (
                <>
                  <div className="col-md-6">
                    <div
                      className="card"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginRight: "15px",
                      }}
                    >
                      <div className="card-body">
                        <p>({toRoman(index + 1)}) Director Details</p>
                        <Container>
                          <div className="row">
                            <div className="col-md-6">
                              <p>
                                <span className="">(i) Name : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.name}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (ii) Nationality : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {countryId[row.country_id] || ""}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (iii) Phone : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.phone}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (iv) E-mail : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.email}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">
                                  {" "}
                                  (v) Website (Optional) :{" "}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.website}
                                </span>
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                  </div>
                </>
              ))}

              <h6 style={{ textAlign: "left", color: "gray", padding: "10px" }}>
                (b) Creator(s) Details
              </h6>
              {createrDetails.map((row, index) => (
                <>
                  <div className="col-md-6">
                    <div
                      className="card"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        marginRight: "15px",
                      }}
                    >
                      <div className="card-body">
                        <p>({toRoman(index + 1)}) Creator Details</p>
                        <Container>
                          <div className="row">
                            <div className="col-md-6">
                              <p>
                                <span className="">(i) Name : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.name}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (ii) Nationality : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {countryId[row.country_id] || ""}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (iii) Phone : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.phone}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className=""> (iv) E-mail : </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.email}
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="">
                                  {" "}
                                  (v) Website (Optional):
                                </span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <span className="titleoffield-view-span-ott">
                                  {" "}
                                  {row.website}
                                </span>
                              </p>
                            </div>
                          </div>
                        </Container>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              <p className="text-danger mt-2">
                NOTE: Name of the Director(s)/ Creator(s) will be credited as
                declared in the application form. No request for the change of
                name would be entertained at any stage.
              </p>

              {/* <h6 style={{ 
                textAlign: "left", 
                color: "gray", 
                padding: "10px" 
              }}
                >
               <b> 7. Other Details</b> <span className="text-danger"> *</span>{" "}
              </h6>
              <div className="col-md-12">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "15px",
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(i) Story Writer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.story_writer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className=""> (ii) Screenplay Writer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.screening_writer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">
                            (iii) Director of Photography :{" "}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.director_of_photography}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(iv) Editor : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.editior}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(v) Art Director : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.art_director}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(vi) Costume Designer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.costume_director}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(vii) Director of Music : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.music_director}{" "}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(viii) Sound Designer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.sound_designer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(ix) Principal cast : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.principal_cast}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Container>
        </Container>

        <Container className="viewPrint mt-4">
          <p>
            <span className="titleoffield-view-ott">
              <b>7. Other Details </b>
              <span className="text-danger"> *</span>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginRight: "15px",
                  }}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(i) Story Writer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.story_writer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className=""> (ii) Screenplay Writer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.screening_writer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">
                            (iii) Director of Photography :{" "}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.director_of_photography}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(iv) Editor : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.editior}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(v) Art Director : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.art_director}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(vi) Costume Designer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.costume_director}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(vii) Director of Music : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.music_director}{" "}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(viii) Sound Designer : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.sound_designer}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <span className="">(ix) Principal cast : </span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <span className="titleoffield-view-span-ott">
                            {" "}
                            {formData.principal_cast}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Container>

        {/* Step 6 Document's */}
        <Container className="viewPrint mt-2">
          {/* <h5>6. Document's</h5> */}
          <p>
            <span className="titleoffield-view-ott">
              <b>8. Documents</b> <span className="text-danger"> *</span>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view">(a) Schedule 1 :</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    <FilePresentIcon /> {formData?.documentData?.[9]?.name}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (b) Synopsis of the Web Series (Precise, not exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  {formData?.synopsis}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (c) Brief profile of Creator(s) (Precise, not exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {" "}
                    <FilePresentIcon />
                    {formData?.documentData?.[2]?.name}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (d) Brief profile of Director(s) (Precise, not Exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    <FilePresentIcon /> {formData?.documentData?.[3]?.name}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view">
                    (e) Brief profile of Producer(s) (Precise, not exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {" "}
                    <FilePresentIcon /> {formData?.documentData?.[4]?.name}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-12">
                <p className="mt-2">
                  <span className="text-danger ">
                    NOTE: In case of multiple director(s), creator(s),
                    producer(s), their profile should be consolidated in one
                    document.
                  </span>
                </p>
              </div>
            </div>
          </Container>
          
        </Container>

        <Container className="viewPrint mt-2">
          <p>
            <span className="titleoffield-view-ott">
              <b>9. Online streaming link (only vimeo or google Drive or similar platform links acceptable)</b> <span className="text-danger"> *</span>
            </span>
          </p>
          <div className="row">
                <div class="col-md-6">
                  Online Link : <a href={`${formData?.online_link}`}>{formData?.online_link}</a>
                </div>
                <div class="col-md-6">
                  Online Password: {formData?.online_password}
                </div>
              </div>

        </Container>

        {/* Dicleration & pament details */}
        <Container className="mt-4">
          <p>
            <span className="titleoffield-view-ott">
              <b>
                10. I/We give consent to screen the web series for consideration
                for Best Web Series (OTT) Award
              </b>
            </span>
          </p>
          <div>
            <Container className="note_p">
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/we have No objection to the screening of this web series for
                  the preview committee, jury, or any of their panels, as well
                  as the use of web series stills/posters, trailers/visual clips
                  by the Ministry of Information and Broadcasting, Government of
                  India, for the purpose of promoting the International Film
                  Festival of India (IFFI) or any other associated events.
                </p>
              </div>
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/we declare that I/we have read the Best web series (OTT)
                  Award Regulations and accept them without reservation. In
                  particular, I/we note the conditions of Clause 6.5 of the
                  Regulations stipulating that my/our entry will be rejected
                  unless the entry form along with all the required material is
                  received by the Ministry of Information and Broadcasting,
                  Government of India on or before submission deadline.
                </p>
              </div>
              {/* <div className="note-check">
                <CheckBoxIcon />
                <p>
                  Only one entry has been submitted by me/ us. In case more than
                  one entry is submitted by me/ us, I understand that the
                  entries are liable to be rejected.
                </p>
              </div> */}
              <div className="note-check">
                <CheckBoxIcon />
                <p>
                  I/We hereby declare that the information provided is true to
                  the best of my/our knowledge and corresponds with the credit
                  titles of the web series. I/we also understand that the
                  Ministry of Information and Broadcasting, Government of India
                  has the right to reject any entry at any stage, if the
                  information entered in this form is found to be incomplete or
                  incorrect.
                </p>
              </div>
            </Container>
          </div>
        </Container>

        <Container className="viewPrint mt-2">
          {/* <h4>7. Transaction Details</h4> */}
          <p>
            <span className="titleoffield-view-ott">
              <b>11. Transaction Details</b>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">Transaction Date : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {convertDateToIndianFormat(
                      formData?.payment_response?.created_at
                    )}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">Bank Reference Number : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData?.payment_response?.bank_ref_no}{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">Amount : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    Rs {formData?.payment_response?.amount}/-{" "}
                  </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">Status : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData?.payment_response?.auth_status === "0300"
                      ? "Success"
                      : "Declined"}{" "}
                  </span>
                </p>
              </div>
            </div>
          </Container>
        </Container>

        {/* Step Additional Info */}
        <Container className="viewPrint mt-2">
          {/* <h4>8. Applicant Details</h4> */}
          <p>
            <span className="titleoffield-view-ott">
              <b>12. Applicant Details</b>
            </span>
          </p>
          <Container maxWidth="lg">
            <div className="row">
              <div class="col-md-6">
                <p>
                  <span className="">Name Of The Applicant : </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.name_of_the_applicant}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">Contact number : </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.contact_number}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">Print Date : </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {currDate} {currTime}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">E-mail : </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.email}{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">Designation : </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="titleoffield-view-span-ott">
                    {formData.designation}{" "}
                  </span>
                </p>
              </div>
            </div>
          </Container>
        </Container>

        <Container className="" style={{ marginTop: "100px" }}>
          <Container>
            <div>
              <p>Signature</p>
              <p>Seal</p>
            </div>
          </Container>
        </Container>
      </div>

      {/* Botton butns of ott View Page  */}
      <Container style={{ padding: "10px" }}>
        <div className="d-flex justify-content-between">
          <Button
            variant="outlined"
            href={process.env.REACT_APP_BASE_PREFIX + "/dashboard"}
          >
            Dashboard
          </Button>
          <StickyButton
            variant="contained"
            color="success"
            onClick={handlePrint}
          >
            Print
          </StickyButton>
        </div>
      </Container>
    </>
  );
};

export default OttView;
